/**
 * Backup tables render progressively: a KeHE scan backup can carry thousands of lines × ~22
 * columns, and rendering every cell at once froze the page ("Page Unresponsive") on brand laptops.
 */
export const BACKUP_PAGE_SIZE = 100

/** How many rows to show after one more "Show more" click, never past the total. */
export function next_visible_count(current: number, total: number, page_size: number = BACKUP_PAGE_SIZE): number {
  return Math.min(total, current + page_size)
}

/** How many rows the next "Show more" click would add (0 when everything is shown). */
export function next_page_size(current: number, total: number, page_size: number = BACKUP_PAGE_SIZE): number {
  return Math.max(0, next_visible_count(current, total, page_size) - Math.min(current, total))
}
